import {Suspense, useCallback, useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import trackPathForAnalytics from '../trackPathForAnalytics'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'

const App = () => {

  const { pathname, search } = useLocation();

    const analytics = useCallback(() => {
        trackPathForAnalytics({ path: pathname, search: search, title: pathname.split("/")[1] });
    }, [pathname, search]);
	
    useEffect(() => {
        analytics();
    }, [analytics]);
    
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
